@if (!!field.alignment && field.alignment === 1) {
  <div class="checkbox-group" [ngClass]="{'admin-group-config':parent.isAdminGroupConfig()}">
    <div class="checkbox-label checkboxlabel">
      <span [title]="field.checkLabel">{{field.checkLabel}}</span>
    </div>
    <div class="checkbox-list" id="{{field.name}}">
      @if (!field.fieldColumnNames) {
        @for (subField of field.buttonMap; track subField; let i = $index) {
          <div class="checkbox-item">
            <edx-radio-field [itemIndex]="i" [radioId]="getRadioId(i)" [value]="subField.value"
              [label]="" [field]="field" [form]="form" [parent]="this"
              [formReadonly]="formReadonly" [inDialog]="inDialog" [columnView]="columnView"
              [radioGroup]="this" [tabIndex]="tabIndex" [rerender]="rerender">
            </edx-radio-field>
          </div>
        }
      } @else {
        @for (column of field.fieldColumnNames; track column; let i = $index) {
          <div class="checkbox-item checkboxlabel">
            <span>{{column}}</span>
          </div>
        }
      }
    </div>
  </div>
} @else {
  <div class="radio-group" id="{{field.name}}" [ngClass]="{indialog:inDialog||inNotify, columnview:columnView, haslabel:hasLabel, footer: parent.isShowFooterOptions(field)}">
    @for (button of field.buttonMap; track button; let i = $index) {
      <div [ngClass]="{readonly:viewReadonly, footerradiobutton:parent.isShowFooterOptions(field)}">
        @if (!field.isCheckboxGroup) {
          <edx-radio-field [itemIndex]="i" [radioId]="getRadioId(i)" [value]="button.value" [label]="button.display" [field]="field" [form]="form" [parent]="this" [formReadonly]="formReadonly" [inDialog]="inDialog" [columnView]="columnView" [radioGroup]="this" [tabIndex]="tabIndex"></edx-radio-field>
        }
      </div>
    }
  </div>
}
